/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable no-shadow */

import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import {
  format,
  lightFormat,
  addDays,
} from 'date-fns'
import {
  LOGO_RENDITIONS,

  STV_COOKIES,
  MOBILE_GUIDE_CARD_RENDITIONS,
  GUIDE_CARD_RENDITIONS,
} from '../../constants'
import Live from './Live'
import withPlayerApi from '../../hocs/withPlayerApi'
import cookies from '../../utils/cookies'
import setPageName from '../../utils/pageName'
import { fetchLoginEnabled, setHideSponsor } from '../../actions'
import { HOST } from '../../utils/env'
import { groupFromResults, groupFromPersonalisedRecommendations } from '../../utils/remapPromotedGroupAssets'
import handleApiError from '../../utils/handleApiError'
import getImageRenditions from '../../utils/getImageRenditions'
import isLive from '../../utils/isLive'

const LiveContainer = (props) => {
  const { loginChecked } = useSelector(state => state.user)
  useEffect(() => {
    setPageName({
      page: 'live',
      guid: props?.root ? null : props?.channel,
    })
  }, [])
  return <Live loginChecked={loginChecked} {...props} />
}

LiveContainer.propTypes = {
  root: PropTypes.bool.isRequired,
  channel: PropTypes.string.isRequired,
}

const apiParams = ({ order, groupToken }) => ({
  limit: 8,
  orderBy: order,
  groupToken,
})

const groups = {
  recommended: {
    id: 'recommended-group',
    type: 'recommended',
    slug: 'stv-recommended-recommended-for-you',
    name: 'Recommended For You',
  },
  mostPopular: {
    id: 'most-popular-group',
    type: 'mostPopular',
    slug: 'most-popular',
    name: 'Most Popular',
  },
}
const getSquaredLogo = (streamArray, channel) => {
  const squareLogo = streamArray?.find(item => item.id === channel)
  return squareLogo ? squareLogo?.logo : null
}
export const getRecommendations = async ({
  hostname,
  userId,
  optIn,
  playerApi,
  groupToken,
}) => {
  let promoted

  if (userId && optIn) {
    const recommended = await playerApi({
      path: `/recommended/viewer/${userId}`,
      query: apiParams({ groupToken }),
    })

    const group = groups.recommended
    promoted = groupFromPersonalisedRecommendations({
      promotedGroup: group,
      hostname,
      results: recommended,
    })
  } else {
    const mostPopular = await playerApi({
      path: '/episodes',
      query: apiParams({ order: '-views', groupToken }),
    })

    const group = groups.mostPopular
    promoted = groupFromResults({
      promotedGroup: group,
      hostname,
      results: mostPopular,
    })
  }
  return promoted
}

export const extractStreamMenuItems = currentChannel => stream => ({
  id: stream.channel,
  title: stream.title,
  href: `/live/${stream.channel}`,
  query: `/live?channel=${stream.channel}`,
  isActiveItem: currentChannel === stream.channel,
  description: stream.description,
  logo: getImageRenditions(stream?.custom?.squareChannelImage?._filepath, LOGO_RENDITIONS),
  sportsExclusive: stream.premierSportsExclusive,
})

const extractScheduleData = e => ({
  title: e?.title,
  channel: e?.channel,
  summary: e?.summary,
  link: e?.programme && e?.programme?._permalink && `/summary/${e?.programme?.guid}`,
  restartEnabled: Boolean(Number(e?.restartEnabled)),
  episode: e?.episode,
  startTime: e?.startTime,
  endTime: e?.endTime,
  id: `${e?.channel}_${e?.startTime}`,
  image: getImageRenditions(
    e?.programme?.images?.[7]?._filepath,
    MOBILE_GUIDE_CARD_RENDITIONS,
  ),
  modalImage: getImageRenditions(
    e?.programme?.images?.[0]?._filepath,
    GUIDE_CARD_RENDITIONS
  ),
})

const getSchedule = async (playerApi, channel) => {
  try {
    const date = format(new Date(), 'yyyy-MM-dd')
    const tomorrow = addDays(new Date(date), 1)
    const dateList = lightFormat(tomorrow, 'yyyy-MM-dd').split('-')

    const { results, reason: scheduleError } = await playerApi({
      path: `/schedule/`,
      query: {
        startTime: `>=${date} 05:15:00`,
        endTime: `<=${dateList[0]}-${dateList[1]}-${dateList[2]} 06:01:59`,
        orderBy: 'startTime',
        limit: 200,
        channel,
      },
    })

    if (scheduleError) return { error: handleApiError({ apiError: scheduleError }) }

    const filteredResults = results.map(extractScheduleData)
    let scheduleAssets = null

    // Find current live program and next 2 programs
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < filteredResults.length; i++) {
      if (isLive(results[i].startTime, results[i].endTime)) {
        scheduleAssets = filteredResults.slice(i, i + 3)
        break
      }
    }

    return {
      hasSchedule: Boolean(scheduleAssets),
      scheduleAssets,
    }
  } catch (err) {
    return {
      hasSchedule: false,
      scheduleAssets: null,
    }
  }
}

const getPromoBanner = async () => {
  const currentDate = new Date().toISOString()
  const url = `https://strapi.cms.${HOST}/api/basic-promo-banners?&populate=deep&filters[Platforms][web]=true&filters[CampaignStartDate][$lt]=${currentDate}&filters[CampaignEndDate][$gt]=${currentDate}`

  try {
    const json = await fetch(url).then(response => response.json())
    return json
  } catch (err) {
    return {
      content: `Oops. Article not found.`,
      articleNotFound: true,
      err,
      ...err && ({
        title: 'Article not found',
      }),
    }
  }
}

LiveContainer.getInitialProps = async ({
  req,
  res,
  query,
  reduxStore,
  playerApi,
}) => {
  await reduxStore?.dispatch(fetchLoginEnabled(playerApi))
  const { loginEnabled } = reduxStore?.getState()?.loginStatus

  const {
    STV_GROUPTOKEN,
    STV_AUTH_REQUIRED,
    STV_USERID,
    STV_PERSONALISATION_OPTIN,
  } = STV_COOKIES

  const groupTokenCookie = cookies.get(STV_GROUPTOKEN, req)
  const sendAuthHeader = cookies.get(STV_AUTH_REQUIRED, req) === 'true'
  const fetchChannel = options => playerApi({
    path: '/channels',
    ...options,
  })
  let groupToken
  const hydrateReduxStore = (groupTokenCookie, loginEnabled) => {
    if (groupTokenCookie && groupTokenCookie !== 'undefined') {
      groupToken = groupTokenCookie
    } else {
      groupToken = loginEnabled ? '0010' : '0071'
    }

    return fetchChannel({
      dispatch: reduxStore?.dispatch,
      sendGroupToken: true,
      query: {
        groupToken,
      },
      sendAuthHeader,
    })
  }

  let { results: streams, reason } = await hydrateReduxStore(groupTokenCookie, loginEnabled)
  let error = null
  if (reason) {
    error = handleApiError({ res, apiError: reason })
    // even if you're not logged in, we want to show the page, and let it be indexed
    if (error.code === 'NOT_LOGGED_IN') {
      ({ results: streams, reason } = await hydrateReduxStore('0071', loginEnabled))
    }
  }

  const opts = {
    dispatch: reduxStore?.dispatch,
    sendGroupToken: true,
    sendAuthHeader,
    query: {
      groupToken,
    },
  }

  const channel = query?.channel || streams?.[0]?.channel || 'stv'

  const { reason: streamsError } = await playerApi({
    ...opts,
    path: `/streams/${channel}`,
  })

  if (streamsError && !error) {
    error = handleApiError({ res, apiError: streamsError })
  }

  const streamMenuItems = streams && streams.map(extractStreamMenuItems(channel))
  const logo = getSquaredLogo(streamMenuItems, channel)
  const programmeOrChannelGuid = channel
  const activeStreamMenuItem = streamMenuItems
    ? streamMenuItems.find(item => item.isActiveItem)
    : null

  const { sportsExclusive } = activeStreamMenuItem
  const root = typeof query.channel === 'undefined'
  const title = root || !activeStreamMenuItem
    ? `Watch Live | STV Player`
    : `${activeStreamMenuItem.title} Live | STV Player`
  const description = !activeStreamMenuItem || !activeStreamMenuItem.description || root
    ? `Experience Scotland's favorite shows on STV Player. Stream local news, popular TV programs, and exclusive series. Access live and on-demand content now!`
    : activeStreamMenuItem.description

  let promoted
  const hostname = req?.headers.host.split(':')[0] || window.location.hostname
  const userId = cookies.get(STV_USERID, req)
  const optIn = cookies.get(STV_PERSONALISATION_OPTIN, req) === 'true'
  const menuTitle = activeStreamMenuItem?.title ? activeStreamMenuItem?.title : channel

  try {
    promoted = await getRecommendations({
      hostname,
      userId,
      optIn,
      playerApi,
      groupToken,
    })
  } catch (recError) {
    try {
      return JSON.stringify(recError)
    } catch (e) {
      return 'Unable to display error details'
    }
  }

  const strapiData = await getPromoBanner()
  const VIPUser = cookies.get('STV_VIP_OPTIN', req) === 'true'

  const { results: onNowNextKillSwitchNumber } = await playerApi({
    path: '/settings/playerWebLiveNowNextCardsDisabled',
    query: { groupToken: '0071' },
  })
  const { results: concurrencyCapKillswitchNum } = await playerApi({
    path: '/settings/concurrencyCappingFallbackWeb',
    query: { groupToken: '0071' },
  })
  await reduxStore?.dispatch(setHideSponsor(sportsExclusive))

  const onNowNextKillSwitch = Boolean(Number(onNowNextKillSwitchNumber))
  const concurrencyCapKillswitch = Boolean(Number(concurrencyCapKillswitchNum))

  const { hasSchedule, scheduleAssets } = await getSchedule(playerApi, channel)

  return {
    error,
    channel,
    programmeOrChannelGuid,
    streamMenuItems,
    root,
    groupToken,
    title,
    description,
    loginEnabled,
    logo,
    promoted,
    strapiData,
    VIPUser,
    menuTitle,
    onNowNextKillSwitch,
    concurrencyCapKillswitch,
    hasSchedule,
    scheduleAssets,
    sportsExclusive,
  }
}

export default withPlayerApi(LiveContainer)
